export const toggleForm = () => ({
  type: 'TOGGLE_FORM'
});

export const closeModal = () => ({
  type: 'SHORTENER_CLOSE_MODAL'
});


export const linkClick = (link) => ({
  type: 'LINK_CLICK',
  link
});




// WEBPACK FOOTER //
// ./src/actions/UiActions.jsx